import {action, computed, observable, runInAction} from 'mobx'
import {get, json} from '../../../../utils/ajax'
import {isAuthenticated} from '../../../../utils/Session'
import {handleSearchAndPage, setStore} from '../../../../utils/Utils'
import {message} from "antd";

class NewsStore {

    @observable newsList //列表数据
    @observable newsPagination //分页
    @observable loading //页面加载
    @observable modal //模态对话框
    @observable searchFields //条件搜索
    @observable pageList //下拉框
    @observable categoryList //栏目
    @observable languageCodeList//语言编码列表
    @observable editFields//信息
    @observable option  //用于判断上传父级、子级
    @observable info //新增时用于存储父级信息
    @observable editorContent// 设置编辑器的内容
    @observable isShow
    @observable modalTile  //模态框名

    constructor() {
        this.newsList = []
        this.newsPagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.loading = false
        this.modal = false
        this.searchFields = {
            title: ''
        }
        this.pageList = []
        this.categoryList = []
        this.languageCodeList = []
        this.editFields = {
            id: '',
            pageId: '',
            categoryId: '',
            language: 'zh',
            title: '',
            level: '',
            pId: '',
            newsNumber: ''
        }
        this.option = ''
        this.info = {}
        this.editorContent = null
        this.isShow = false
        this.modalTile = ''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 新闻列表
     * 分页
     */
    @action
    initNewsPage = async (page) => {
        this.loading = true
        let search = handleSearchAndPage(page, this.newsPagination, this.searchFields)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/news_page:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.newsList = res.content || []
            this.newsPagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }

    /**
     * 搜索框：平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            title: {value: this.searchFields.title},
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onSearchFieldChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let searchFields = {
            title: fields.title.value ? fields.title.value : '',
        }
        this.searchFields = searchFields
    }

    /**
     * 搜索框：清空
     */
    @action
    clearSearchForm = () => {
        runInAction(() => {
            this.loading = this
            this.searchFields = {
                title: ''
            }
            this.loading = false
        })
    }

    /**
     * 删除
     * 如果有子级，删除按钮不予显示
     */
    @action
    deleteNews = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/delete?id=${id}`)
        runInAction(() => {
            this.initNewsPage(this.newsPagination.current)
            this.loading = false
        })
    }

    /**
     * 启用新闻
     * 如果该新闻所属栏目未启用，不允许启用
     * @param id
     * @returns {Promise.<void>}
     */
    @action
    releaseNews = async (id) => {
        runInAction(() => this.loading = true);
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/release/${id}`)
        runInAction(() => {
            if (res.status !== 1) {
                message.warn('启用失败')
            } else {
                message.success('启用成功')
            }
            this.initNewsPage(this.newsPagination.current);
            this.loading = false
        })
    }

    /**
     * 停用新闻
     * 如果该新闻下有子新闻启用，不允停用
     * @param id
     * @returns {Promise.<void>}
     */
    @action
    stopNews = async (id) => {
        runInAction(() => this.loading = true)
        const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/stop/${id}`)
        runInAction(() => {
            if (res.status !== 1) {
                message.warn('停用失败')
            } else {
                message.success('停用成功')
            }
            this.initNewsPage(this.newsPagination.current);
            this.loading = false
        })
    }

    /**
     * 获得语言编码列表
     */
    @action
    getLanguageCodeList = async () => {
        let res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/getOneRoot`, {name: '语言/'})
        runInAction(() => {
            this.languageCodeList = res.children || []
            //去除字典表语言中的中文
            /*this.languageCodeList = this.languageCodeList.slice().filter((item, i) => item.code !== 'zh')*/
        })
    }

    /**
     * 页面下拉框
     * @returns {Promise.<void>}
     */
    @action
    getPageList = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/page/list`)
        runInAction(() => {
            this.pageList = Array.isArray(res) ? res : []
            this.loading = false
        })
    }

    /**
     * 所有的栏目
     * @returns {Promise.<void>}
     */
    @action
    getAllCategory = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/category/all`)
        runInAction(() => {
            this.categoryList = Array.isArray(res) ? res : []
            this.loading = false
        })
    }

    /**
     * 选择页面时获取该页面下的栏目
     */
    @action
    getCategoryByPage = async (value) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/category/under_same_page/${value}`)
        runInAction(() => {
            this.categoryList = res || []
            this.loading = false
        })
    }

    /**
     * 新增-修改 平行化
     * @returns {{name: {value: string}}}
     */
    @computed
    get fieldsEdit() {
        let editFields = {
            id: {value: this.editFields.id},
            pageId: {value: this.editFields.pageId},
            categoryId: {value: this.editFields.categoryId},
            language: {value: this.editFields.language},
            title: {value: this.editFields.title},
            level: {value: this.editFields.level},
            pId: {value: this.editFields.pId},
            newsNumber: {value: this.editFields.newsNumber}
        }
        return editFields
    }

    /**
     * 新增-修改 数据回写
     * @param changedFields
     */
    @action
    onEditFieldChange(changedFields) {
        const fields = {...this.fieldsEdit, ...changedFields}
        let editFields = {
            id: fields.id.value ? fields.id.value : '',
            pageId: fields.pageId.value ? fields.pageId.value.trim() : '',
            categoryId: fields.categoryId.value ? fields.categoryId.value.trim() : '',
            language: fields.language.value ? fields.language.value.trim() : '',
            title: fields.title.value ? fields.title.value.trim() : '',
            level: fields.level.value ? fields.level.value : '',
            pId: fields.pId.value ? fields.pId.value.trim() : '',
            newsNumber: fields.newsNumber.value ? fields.newsNumber.value.trim() : ''
        }
        this.editFields = editFields
    }

    /**
     * 上传图片
     */
    uploadImage = (blobInfo, success, failure) => {
        const formData = new FormData()
        formData.append('type', 'file')
        formData.append('file', blobInfo.blob())
        // fetch(`${config.apiUrl}`, {
        fetch(`${process.env.REACT_APP_API_URL}/onestep/base/upload`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'x-access-token': isAuthenticated(),
            },
            body: formData
        }).then(response => {
            return response.text()
        }).then(text => {
            success(text)
        })
    }


    /**
     *  弹窗：显示
     *  option: addSon:新增下级 addFather：新增父级
     *  不存在:修改   存在：新增
     */
    @action showModal = (record, option) => {
            this.loading = true
            this.modalTile = option==='update'?'修改':'新增'
            this.modal = true
            if (option === 'update') {  //修改
                this.editFields = record
                this.option = option
                this.editorContent = record.content
                this.isShow = true
            } else if (option === 'addSon') {     //新增下级
                this.option = option
                this.info = record
                this.isShow = true
                this.editFields = {
                    id: '',
                    pageId: this.info.pageId,
                    categoryId: this.info.categoryId,
                    language: '',
                    title: '',
                    level: '',
                    pId: '',
                    newsNumber: ''
                }
            } else {     //新增父级
                this.editorContent = null
                this.isShow = true
                this.editFields = {
                    id: '',
                    pageId: '',
                    categoryId: '',
                    language: 'zh',
                    title: '',
                    level: '',
                    pId: '',
                    newsNumber: ''
                }
            }
            this.loading = false
    }

    /**
     * 弹窗：关闭
     */
    @action
    closeModal = () => {
        this.editorContent = ''
        runInAction(() => {
            this.loading = true
            this.editFields = {
                id: '',
                pageId: '',
                categoryId: '',
                language: '',
                title: '',
                level: '',
                pId: '',
                newsNumber: ''
            }
            this.isShow = false
            this.option = ''
            this.modal = false
            this.loading = false
        })
    }

    /**
     * 保存：新增/修改
     */
    @action saveNews = async () => {
        runInAction(() => {
            this.loading = true
        })
        let data = {
            id: this.editFields.id,
            pageId: this.editFields.pageId,
            categoryId: this.editFields.categoryId,
            language: this.editFields.language,
            title: this.editFields.title,
            content: this.editorContent,
            level: this.editFields.level,
            pId: this.editFields.pId,
            newsNumber: this.editFields.newsNumber
        }
        if (this.option === 'update') {
            let res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/update`, data) //修改
            if (res.status === 0) {
                this.loading = false
                return
            }
            if (res.status) {
                message.success('修改成功！')
            }
        } else if (this.option === 'addSon') {
            data.level = this.info.level + 1
            data.pId = this.info.id
            let res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/add`, data) //新增下级
            if (res.status === 0) {
                this.loading = false
                return
            }
            if (res.status) {
                message.success('新增下级成功！')
            }
        } else {
            data.level = 1;
            data.pId = '0';
            let res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/add`, data) //新增父级
            if (res.status === 0) {
                this.loading = false
                return
            }
            if (res.status) {
                message.success('新增父级成功！')
            }
        }
        runInAction(() => {
            this.loading = false
            this.modal = false
            this.editFields = {}
            this.isShow = false
            this.initNewsPage(this.newsPagination.current)
            // this.editorContent=ContentUtils.clear(this.editorContent)
        })
    }

    /**
     * 富文本编辑器的内容改变
     * @param value
     */
    @action
    handleEditorChange = (value) => {
        this.editorContent = value
    }

    /**
     * 上传图片
     */
    uploadImage = (blobInfo, success, failure) => {
        const formData = new FormData()
        formData.append('type', 'file')
        formData.append('file', blobInfo.blob())
        fetch(`${process.env.REACT_APP_API_URL}/onestep/base/upload`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'x-access-token': isAuthenticated(),
            },
            body: formData
        }).then(response => {
            return response.text()
        }).then(text => {
            success(text)
        })
    }
}

export default new NewsStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/sparePartsCatalogueNews/News/store.js